/**
 * Builds a single Matrix-shaped "provider" (fornecedor -> produtos -> lojas)
 * on demand from the same flat `products` array Matriz/Por Produto/Por Loja
 * all receive from pre_orders_report() — filtered to one seller+provider
 * pair. Mirrors `_matrix.table.vue`'s own `process_available_providers()` +
 * `padProductStores()`, minus the CROSS/DEPOSIT cell-locking rules (the
 * consumer, ProviderMatrixModal, doesn't render those special cases either).
 *
 * Used to open a seller's full pré-pedido matrix (ProviderMatrixModal) from
 * tables that aren't provider-grained internally, so they don't already have
 * this object lying around like Matriz does.
 *
 * @returns {object|null} null when this seller/provider has no rows at all.
 */
export function buildSellerProviderMatrix(products, sellerId, providerId, stores = []) {
    const matching = products.filter(
        (p) => p.seller_id == sellerId && p.provider_id == providerId
    );

    if (!matching.length) return null;

    const first = matching[0];

    const provider = {
        key: `${providerId}-${sellerId}`,
        provider_id: providerId,
        seller_id: sellerId,
        nomeFornecedor: first.provider_name,
        nomeVendedor: first.seller_name,
        telefone: first.seller_phone,
        minimumBilling: first.minimum_billing,
        cnpj: first.provider_cnpj,
        paymentCondition: first.payment_condition,
        expectedDate: first.expected_date,
        deliveryType: first.delivery_type,
        products: [],
    };

    matching.forEach((rawPp) => {
        const pp = Object.freeze({ ...rawPp });
        const pro = provider.products.find((p) => p.id == pp.id);

        if (pro) {
            const index = pro.stores.findIndex((s) => s.store_id == pp.store_id);

            if (index === -1) pro.stores.push(pp);
            else pro.stores.splice(index, 1, pp);
        } else {
            provider.products.push({ ...pp, stores: [pp] });
        }
    });

    provider.products.forEach((product) => {
        stores.forEach((store) => {
            const exists = product.stores.some((s) => s.store_id == store.id);

            if (!exists) {
                const baseStore = product.stores[0] || {};

                product.stores.push(Object.freeze({
                    ...baseStore,
                    store_id: store.id,
                    requested_quantity: 0,
                    isNewStore: true,
                }));
            }
        });
    });

    return provider;
}
